export default [
  {
    path: '/nomina/request/details',
    name: 'request',
    component: () => import('@/views/nomina/request.vue'),
    meta: {
      pageTitle: 'Detalle solicitudes',
      breadcrumb: [
        {
          text: 'Solicitudes',
          active: false,
        },
        {
          text: 'Detalle',
          active: true,
        },
      ],
      resource: 'GH Nominas',
      action: 'menu',
    },
  },
  {
    path: '/nomina/current',
    name: 'current',
    component: () => import('@/views/nomina/current.vue'),
    meta: {
      pageTitle: 'Nómina actual',
      breadcrumb: [
        {
          text: 'Nómina actual',
          active: true,
        },
      ],
      resource: 'GH Nominas',
      action: 'menu',
    },
  },
  {
    path: '/nomina/view/:id',
    name: 'view',
    component: () => import('@/views/nomina/view.vue'),
    meta: {
      pageTitle: 'Ver puesto',
      breadcrumb: [
        {
          text: 'Nomina Actual',
          active: false,
        },
        {
          text: 'Detalle',
          active: false,
        },
        {
          text: 'Ver',
          active: true,
        },
      ],
    },
  },
  {
    path: '/nomina/view/presented/:id',
    name: 'presented',
    component: () => import('@/views/nomina/presented.vue'),
    meta: {
      pageTitle: 'Ver solicitud presentada',
      breadcrumb: [
        {
          text: 'Nomina Actual',
          active: false,
        },
        {
          text: 'Detalle',
          active: false,
        },
        {
          text: 'Ver',
          active: true,
        },
      ],
    },
  },
  {
    path: '/nomina/reportes',
    name: 'reports',
    component: () => import('@/views/nomina/reports.vue'),
    meta: {
      pageTitle: 'Reportes de Nomina',
      breadcrumb: [
        {
          text: 'Reportes',
          active: true,
        },
      ],
      resource: 'GH Nominas',
      action: 'menu',
    },
  },
  {
    path: '/nomina/request/new',
    name: 'new',
    component: () => import('@/views/nomina/new.vue'),
    meta: {
      pageTitle: 'Nuevo puesto',
      breadcrumb: [
        {
          text: 'Solicitudes',
          active: false,
        },
        {
          text: 'Detalle',
          active: false,
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
      resource: 'GH Nominas',
      action: 'menu',
    },
  },
  {
    path: '/nomina/request/edit/:id',
    name: 'edit',
    component: () => import('@/views/nomina/edit.vue'),
    meta: {
      pageTitle: 'Editar puesto',
      breadcrumb: [
        {
          text: 'Solicitudes',
          active: false,
        },
        {
          text: 'Detalle',
          active: false,
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      resource: 'GH Nominas',
      action: 'menu',
    },
  },
  {
    path: '/nomina/request/weeks',
    name: 'weeks',
    component: () => import('@/views/nomina/weeks.vue'),
    meta: {
      pageTitle: 'Gestionar semanas',
      breadcrumb: [
        {
          text: 'Solicitudes',
          active: false,
        },
        {
          text: 'Semanas',
          active: true,
        },
      ],
      resource: 'GH Nominas',
      action: 'menu',
    },
  },


  {
    path: '/nomina/admin/currents',
    name: 'admin_currents',
    component: () => import('@/views/nomina/admin/currents.vue'),
    meta: {
      pageTitle: 'Toda la Nómina actual',
      breadcrumb: [
        {
          text: 'Nomina Actual',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/requests',
    name: 'admin_requests',
    component: () => import('@/views/nomina/admin/requests.vue'),
    meta: {
      pageTitle: 'Solicitudes',
      breadcrumb: [
        {
          text: 'Solicitudes',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/requests/edit/:id',
    name: 'admin_edit',
    component: () => import('@/views/nomina/admin/edit.vue'),
    meta: {
      pageTitle: 'Editar puesto',
      breadcrumb: [
        {
          text: 'Solicitudes',
          active: false,
        },
        {
          text: 'Detalle',
          active: false,
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/requests/new',
    name: 'admin_new',
    component: () => import('@/views/nomina/admin/new.vue'),
    meta: {
      pageTitle: 'Nuevo puesto',
      breadcrumb: [
        {
          text: 'Solicitudes',
          active: false,
        },
        {
          text: 'Detalle',
          active: false,
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/currents/view/:id',
    name: 'admin_view',
    component: () => import('@/views/nomina/admin/view.vue'),
    meta: {
      pageTitle: 'Ver puesto',
      breadcrumb: [
        {
          text: 'Actuales',
          active: false,
        },
        {
          text: 'Detalle',
          active: false,
        },
        {
          text: 'Ver',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/reports',
    name: 'admin_reports',
    component: () => import('@/views/nomina/admin/reports.vue'),
    meta: {
      pageTitle: 'Reportes',
      breadcrumb: [
        {
          text: 'Reportes',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/inventory',
    name: 'admin_inventory',
    component: () => import('@/views/nomina/admin/inventory.vue'),
    meta: {
      pageTitle: 'Inventario',
      breadcrumb: [
        {
          text: 'Inventario',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/org_chart',
    name: 'admin_org_chart',
    component: () => import('@/views/nomina/admin/org_chart.vue'),
    meta: {
      pageTitle: 'Organigrama',
      breadcrumb: [
        {
          text: 'Organigrama',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/logs',
    name: 'admin_logs',
    component: () => import('@/views/nomina/admin/logs.vue'),
    meta: {
      pageTitle: 'Logs',
      breadcrumb: [
        {
          text: 'Logs',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/config',
    name: 'admin_config',
    component: () => import('@/views/nomina/admin/config.vue'),
    meta: {
      pageTitle: 'Configuraciones',
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },

  //Registro Nominas
  {
    path: '/nomina/registro_nominas',
    name: 'registronominas',
    component: () => import('@/views/nomina/registro_nominas.vue'),
    meta: {
      pageTitle: 'Descarga Sunat',
      breadcrumb: [
        {
          text: 'Descarga Sunat',
          active: true,
        },
      ],
      resource: 'Registro Nominas',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/config/users',
    name: 'admin_users',
    component: () => import('@/views/nomina/admin/config/users/list/index.vue'),
    meta: {
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: false,
        },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/config/users/edit/:id',
    name: 'admin_users_edit',
    component: () => import('@/views/nomina/admin/config/users/edit/index.vue'),
    meta: {
      pageTitle: 'Editar Usuarios',
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: false,
        },
        {
          text: 'Usuarios',
          active: false,
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/config/users/add',
    name: 'admin_users_add',
    component: () => import('@/views/nomina/admin/config/users/add/index.vue'),
    meta: {
      pageTitle: 'Nuevo Usuario',
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: false,
        },
        {
          text: 'Usuarios',
          active: false,
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/config/budget_year',
    name: 'admin_budget_year',
    component: () => import('@/views/nomina/admin/config/budget_year/index.vue'),
    meta: {
      pageTitle: 'Año Presupuesto',
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: false,
        },
        {
          text: 'Año Presupuesto',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/config/incrementals',
    name: 'admin_incrementals_list',
    component: () => import('@/views/nomina/admin/config/incrementals/list/index.vue'),
    meta: {
      pageTitle: 'Incrementales',
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: false,
        },
        {
          text: 'Incrementales',
          active: true,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },
  {
    path: '/nomina/admin/config/incrementals/edit/:id',
    name: 'admin_incrementals_edit',
    component: () => import('@/views/nomina/admin/config/incrementals/edit/index.vue'),
    meta: {
      pageTitle: 'Incrementales',
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: false,
        },
        {
          text: 'Incrementales',
          active: false,
        },
        {
          text: 'Editar',
          active: false,
        },
      ],
      resource: 'GH Admin',
      action: 'menu',
    },
  },

  //Valorización
  {
    path: '/valorizacion/admin/parameters',
    name: 'Parámetros',
    component: () => import('@/views/valorizacion/admin/parameters.vue'),
    meta: {
      pageTitle: 'Parámetros',
      breadcrumb: [
        {
          text: 'Parámetros',
          active: true,
        },
      ],
      resource: 'GH Valorizacion',
      action: 'menu',
    },
  },
  {
    path: '/valorizacion/admin/add_parameters',
    name: 'add_parameter',
    component: () => import('@/views/valorizacion/admin/add_parameters.vue'),
    meta: {
      pageTitle: 'Agregar Parámetros',
      breadcrumb: [
        {
          text: 'Parámetros',
          active: false,
        },
        {
          text: 'Agregar',
          active: true,
        },
      ],
      resource: 'GH Valorizacion',
      action: 'menu',
    },
  },
  {
    path: '/valorizacion/admin/parameters/:id',
    name: 'view_parameter',
    component: () => import('@/views/valorizacion/admin/view_parameter.vue'),
    meta: {
      pageTitle: 'Ver parámetro',
      breadcrumb: [
        {
          text: 'Parámetros',
          active: false,
        },
        {
          text: 'Ver',
          active: true,
        },
      ],
      resource: 'GH Valorizacion',
      action: 'menu',
    },
  },
  {
    path: '/valorizacion/admin/valuation',
    name: 'Valuation',
    component: () => import('@/views/valorizacion/admin/valuation.vue'),
    meta: {
      pageTitle: 'Valorización',
      breadcrumb: [
        {
          text: 'Valorización',
          active: true,
        },
      ],
      resource: 'GH Valorizacion',
      action: 'menu',
    },
  },
  {
    path: '/valorizacion/admin/add_valuation',
    name: 'add_valuation',
    component: () => import('@/views/valorizacion/admin/add_valuation.vue'),
    meta: {
      pageTitle: 'Nueva Valorización de Nómina',
      breadcrumb: [
        {
          text: 'Valorización',
          active: false,
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
      resource: 'GH Valorizacion',
      action: 'menu',
    },
  },
]
